<template>
  <div>
    <div v-if="!dealerurl" class="touch-scroll">
      <form method="post" novalidate class="lead-form-box" @submit.prevent="submitOffer()">
        <Modal
          id="getoffer"
          ref="getofferRef"
          class="bgcolor-primary"
          @hideModal="closeOffer()"
          :class="isIframe ? 'iframe-modal' : ''"
        >
          <template #title>
            <div :class="['d-block mb-3', isMazda ? 'text-right' : 'text-center']">
              <div class="ft-18 _theme_leadform_heading mt-2">{{ getTitle }}</div>
            </div>
          </template>

          <div v-if="initialdisplay" @focus.capture="onFormFocus">
            <p>Interested in this offer? Enter your email address to receive a copy.</p>
            <div class="lead-form-box">
              <div class="form-group mb-3">
                <input
                  id="firstName"
                  v-model="contactdetails.FirstName"
                  type="text"
                  class="form-control"
                  placeholder="First Name"
                  :class="[{ error: errordetails.firstNameError }]"
                  @keypress="removeSpecialCharacter"
                />
                <label for="firstName">First Name<span>*</span></label>
              </div>
              <div class="form-group mb-3">
                <input
                  id="lastName"
                  v-model="contactdetails.LastName"
                  type="text"
                  class="form-control"
                  placeholder="Last Name"
                  :class="[{ error: errordetails.lastNameError }]"
                  @keypress="removeSpecialCharacter"
                />
                <label for="lastName">Last Name<span>*</span> </label>
              </div>
              <div class="form-group mb-3">
                <input
                  id="emailAddress"
                  v-model="contactdetails.EmailAddress"
                  type="email"
                  class="form-control"
                  placeholder="Email Address*"
                  :class="[{ error: errordetails.emailerror }]"
                />
                <label for="emailAddress">Email Address* </label>
              </div>
              <div v-if="isPhoneOnGetOffer" class="form-group mb-3">
                <input
                  id="phoneNumber"
                  v-model="contactdetails.PhoneNumber"
                  type="text"
                  class="form-control"
                  :placeholder="isPhoneMandatory ? 'Phone number*' : 'Phone number'"
                  :class="[{ error: errordetails.phoneerror }]"
                  @keypress="isNumberKey"
                />
                <label for="phoneNumber">{{
                  isPhoneMandatory ? "Phone number*" : "Phone number"
                }}</label>
                <span v-if="errordetails.phoneerror" class="text-danger ft-15"
                  >Phone Number must be 10 digits</span
                >
              </div>
              <div v-if="showZipCodeOnGetOffer" class="form-group mb-3">
                <input
                  id="zipCode"
                  v-model="contactdetails.Zip"
                  type="text"
                  class="form-control"
                  :placeholder="[[zipDetails.placeHolderText]]"
                  :class="[{ error: errordetails.ziperror }]"
                  @change="initialEvents()"
                />
                <label for="zipCode">
                  {{ zipDetails.placeHolderText }}
                </label>
              </div>
              <div v-if="showCommentsOnGetOffer" class="form-group mb-3">
                <textarea
                  id="textarea"
                  v-model="contactdetails.Message"
                  class="form-control h-100"
                  :placeholder="isCommentsMandatory ? 'Comments*' : 'Comments'"
                  :class="[{ error: errordetails.commentserror }]"
                />
                <label for="textarea">
                  {{ isCommentsMandatory ? "Comments*" : "Comments" }}
                </label>
              </div>
              <shift-ccpa-disclaimer-checkbox
                v-if="loadShiftSpecialFields"
                :formdata="contactdetails"
                :errorobj="errordetails"
              />
            </div>
            <marketing-text-disclaimer
              v-if="isStellantisProgram"
              :marketing-text-consent="marketingTextConsent"
              @updateMarketingTextConsent="updateMarketingconcent"
            />
            <div slot="modal-footer">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <show-disclaimer />
                </div>
                <div class="w-100 mt-2 mt-md-0 input-custom-icon">
                  <input
                    type="submit"
                    value="Send"
                    class="btn btn-lg w-100 bgcolor-primary color-white rounded-buttons _theme_buttons_css theme-bg-color btn-websites button-primary"
                    :disabled="disableSubmit"
                  />
                </div>
              </div>
            </div>
            <div class="mt-2">
              <tcpa-disclaimer @checked="ontcpChecked($event)" />
            </div>
          </div>
          <div>
            <form-submit-message
              :show-message-text="success"
              :lead-type-id="getLeadTypeId()"
              :default-message="defaultSuccessMessage"
            />
          </div>
          <div v-if="mailError">something went wrong please try again later.</div>
        </Modal>
      </form>
    </div>

    <div v-else>
      <lead-iframe :url="dealerurl" title="Get Offer" @hideiframe="iframehide()" />
    </div>
  </div>
</template>
<script>
import Modal from "../../../Shared/Modal/Modal.vue";
import axios from "axios";
import LeadIframe from "../../../Shared/LeadIframe/LeadIframe.vue";
import { Validations } from "../../../../Services/Validations/Validations";
import { Events } from "../../../../Events/ConsumerEvents/Events";
import { LeadService } from "@/js/services/LeadForms/LeadFormService";
import ShowDisclaimer from "@/js/components/leadforms/ShowDisclaimer.vue";
import { LocalStorageService } from "@/js/components/shared/Services/LocalStorageService";
import {
  DWP_Sales_Form_90508,
  DWP_SERVICE_CONTACT_90610,
} from "@/js/services/GoogleTagManager/GoogleTagConstants";
import { TagManagerContainer } from "../../../../Events/GoogleTagManager/TagManagerContainer";
import UtmUrlService from "@/js/services/UtmUrlService";
import DealerGroupService from "@/js/services/DealerGroupService";
import ShiftDigitalContainer from "../../../../Events/ShiftDigital/ShiftDigitalContainer";
import {
  SHIFT_DIGITAL_DEALER_CUSTOM,
  SHIFT_DIGITAL_SERVICE,
  SHIFT_DIGITAL_SPECIALS,
} from "@/js/services/ShiftDigital/ShiftDigitalConstants";
import ShiftDigitalService from "../../../../Events/ShiftDigital/ShiftDigitalService";
import FormOpening from "../../../../Services/FormServices/FormOpening";
import {
  SUBMIT_GET_OFFER_LABEL_UNITE_DIGITAL,
  VEHICLE_OFFER_UNITE_OBJECT,
} from "@/js/services/UniteDigital/UniteDigitalConstants";

import LeadFormSpamCheck from "@/js/services/LeadFormSpamCheck";
import {
  LogLeadApi,
  findIsSalesEventId,
} from "../../../../Services/LogLeadApiService/LogLeadApiService";
import FormSubmitMessage from "../../../Shared/FormSubmitMessage/FormSubmitMessage.vue";
import TcpaDisclaimer from "@/js/components/leadforms/TcpaDisclaimer.vue";
import { frameFaceBookUserDetails } from "@/js/services/FaceBookConversionApiService";
import ShiftCcpaDisclaimerCheckbox from "../../../Shared/ShiftCcpaDisclaimerCheckbox/ShiftCcpaDisclaimerCheckbox.vue";
import { fireTagSpecialPriceEvent } from "../../../../Events/TagManagerServices/TaggingEventForPages";
import { SALES_FORM, SERVICE_FORM } from "../../../../Events/ASCTagManager/ASCTagManagerService";
import { TealiumTireThreeTagManagerContainer } from "../../../../Events/TealiumTireThreeTagging/TealiumTireThreeTagManager";
import MarketingTextDisclaimer from "@/js/components/leadforms/MarketingTextDisclaimer.vue";
import { isStellantisProgram } from "@/js/constants/ThemeConstants";

export default {
  components: {
    Modal,
    "lead-iframe": LeadIframe,
    ShowDisclaimer,
    "form-submit-message": FormSubmitMessage,
    "tcpa-disclaimer": TcpaDisclaimer,
    ShiftCcpaDisclaimerCheckbox,
    MarketingTextDisclaimer,
  },
  props: {
    referFrom: {
      required: false,
      default: "",
      type: String,
    },
    offerid: {
      required: false,
    },
    offerdesignid: {
      required: false,
      default: "",
    },
    styleid: {
      required: false,
      default: "",
    },
    vin: {
      required: false,
      default: "",
    },

    model: {
      required: false,
      default: "",
    },
    make: {
      required: false,
      default: "",
    },
    opengetoffer: {
      type: Boolean,
      required: true,
    },

    consumereventid: {
      required: false,
      default: 0,
    },
    isAidoEvent: {
      required: false,
      default: 0,
    },
    offercategoryid: {
      required: false,
      default: "",
    },
    amount: {
      required: false,
      default: "",
    },
    description: {
      required: false,
      default: "",
    },
    header: {
      required: false,
      default: "",
    },
    disclaimer: {
      required: false,
      default: "",
    },
    pageName: {
      required: false,
      default: "",
    },
    stockNumber: {
      required: false,
      default: "",
      type: String,
    },
  },
  data() {
    return {
      defaultSuccessMessage: `Mail sent successfully.`,
      zipDetails: {},
      dealerurl: "",
      modalShow: false,
      shiftDigital: "",
      success: false,
      initialdisplay: true,
      mailError: false,
      tcpChecked: window.enableTCPAConsent ? false : null,
      pin: window.userpin ? window.userpin : "",
      isPhoneOnGetOffer: !!window.isPhoneOnGetOffer,
      isPhoneMandatory: window.isPhoneMandatoryInLeadForms,
      showZipCodeOnGetOffer: window.showZipCodeOnGetOffer,
      showCommentsOnGetOffer: window.showCommentsOnGetOffer,
      isCommentsMandatory: window.isCommentsMandatory,
      contactdetails: {
        FirstName: window.userDetails.firstname ? window.userDetails.firstname : "",
        LastName: window.userDetails.lastname ? window.userDetails.lastname : "",
        EmailAddress: window.userDetails.email ? window.userDetails.email : "",
        PhoneNumber: window.userDetails.phonenumber ? window.userDetails.phonenumber : "",
        Address: window.fullAddress ? window.fullAddress : "",
        Zip: window.userDetails.zip ? window.userDetails.zip : "",
        Message: "",
        TCPConsent: false,
      },
      errordetails: {
        emailerror: false,
        phoneerror: false,
        ziperror: false,
        commentserror: false,
      },
      disableSubmit: false,
      formShiftDigitalType: "",
      loadShiftSpecialFields: window.showShiftSpecialFields,
      isIframe: window.location !== window.parent.location,
      isFdDealer: window.isFdDealer,
      isMazda: window.themeName?.toLowerCase() === "mazda_oem",
      marketingTextConsent: false,
      isStellantisProgram: isStellantisProgram(),
    };
  },
  computed: {
    getTitle() {
      if (window.themeName?.toLowerCase() === "subaru") {
        if (window.accountId === "64669") {
          return "Claim Coupon";
        } else {
          return "Contact Us";
        }
      } else {
        return "Get Offer";
      }
    },
  },

  mounted() {
    this.fireFordShiftDigitalOnMounted();
    let isIframe = window.location !== window.parent.location;
    if (isIframe) {
      const element = document.getElementById("_website_primary");
      if (element) {
        element.scrollIntoView();
      }
    }
    if (!window.userpin) {
      let contactData = LocalStorageService.getContactdetailsFromLocalStorage();
      this.contactdetails = { ...contactData };
    }
    this.zipDetails = { ...LocalStorageService.zipDetails() };

    let make = window.make.toLowerCase();
    this.formShiftDigitalType = SHIFT_DIGITAL_SPECIALS;
    if (make === "maserati") {
      this.formShiftDigitalType = SHIFT_DIGITAL_DEALER_CUSTOM;
    }
    if (make === "genesis") {
      this.formShiftDigitalType = SHIFT_DIGITAL_SERVICE;
    }
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
    if (this.shiftDigital) {
      this.shiftDigital.setVin(this.vin);
      this.shiftDigital.initiateForm(this.formShiftDigitalType);
      ShiftDigitalService.initiateFormEvents(this.shiftDigital, this.formShiftDigitalType);
    }

    if (
      this.consumereventid !== Events.eventsConstants.gotPreownedOffer &&
      this.consumereventid !== Events.eventsConstants.gotCertifiedPreownedOffer &&
      this.consumereventid !== Events.eventsConstants.gotDealerSpecial &&
      this.consumereventid !== Events.eventsConstants.GotServiceCoupon &&
      this.consumereventid !== Events.eventsConstants.getOffer
    )
      try {
        logGoogleBingEvent(
          "Email",
          "button_click",
          "Getoffer_service",
          1,
          " Get Offer Button Click"
        );
      } catch (e) {
        console.log(e);
      }

    LeadService.getLeadFormUrls().then((response) => {
      this.dealerurl = response.data.makeOfferUrl;
      if (!this.dealerurl) {
        this.$refs.getofferRef.show();
      }
    });
    let tempConsumerEventId;
    if (this.consumereventid === Events.eventsConstants.gotPreownedOffer)
      tempConsumerEventId = Events.eventsConstants.Openapreownedoffer;
    else if (this.consumereventid === Events.eventsConstants.gotDealerSpecial)
      tempConsumerEventId = Events.eventsConstants.Openadealeroffer;
    else if (this.consumereventid === Events.eventsConstants.GotServiceCoupon)
      tempConsumerEventId = Events.eventsConstants.Openaservicecouponoffer;
    else if (this.consumereventid === Events.eventsConstants.getOffer)
      tempConsumerEventId = Events.eventsConstants.Openanewspecialsoffer;
    else if (this.consumereventid === Events.eventsConstants.aidoemailleadform)
      tempConsumerEventId = Events.eventsConstants.ClickedonEmailOfferinAIDOpage;
    else if (this.consumereventid === Events.eventsConstants.Gotapayment)
      tempConsumerEventId = Events.eventsConstants.OpenonEmailOfferinVDPPayments;
    else if (this.consumereventid === Events.eventsConstants.gotCertifiedPreownedOffer)
      tempConsumerEventId = Events.eventsConstants.OpencertifiedpreownedOffer;
    else tempConsumerEventId = Events.eventsConstants.getOffer;
    let eventModel = {
      ...Events.consumerEventModel,
      consumerEventId: tempConsumerEventId,
      offerId: this.offerid ? this.offerid : 0,
      vin: this.vin ? this.vin : 0,
      styleId: this.styleid ? this.styleid : 0,
      stockNumber: this.stockNumber ? this.stockNumber : "",
    };
    Events.logConsumerEvent(eventModel);
    this.contactdetails["TCPConsent"] = window.enableTCPAConsent ? false : null;

    FormOpening.eventTagging(
      {
        ...this.contactdetails,
        LeadTypeID: this.getLeadTypeId(),
        LeadTypeName: "get-offer-CRM",
      },
      this.vin
    );

    if (window.autoToggleTCPA === true) {
      this.tcpChecked = true;
      this.contactdetails["TCPConsent"] = true;
    }

    if (window.showZipCodeField || window.makeZipCodeMandatory) {
      this.showZipCodeOnGetOffer = true;
    }
    let tealium = TealiumTireThreeTagManagerContainer.getDealerObject();
    if (tealium && typeof tealium.tealiumFormCTAAction === "function") {
      tealium.tealiumFormCTAAction({
        vin: this.vin,
        label: "get this offer",
        site_event: "get_this_offer_click",
      });
    }
  },
  methods: {
    closeOffer() {
      this.$emit("hideModal");
    },
    fireFordShiftDigitalOnMounted() {
      let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
      if (shiftDigital && typeof shiftDigital.newSpecialsEmailOfferFormOnLoad === "function") {
        let referFrom =
          this.referFrom && this.referFrom === "preowned" ? "pre-owned" : this.referFrom;
        if (this.referFrom) {
          setTimeout(() => {
            shiftDigital.newSpecialsEmailOfferFormOnLoad(referFrom);
          }, 3000);
        }
      }
    },
    isNumberKey(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    initialEvents() {
      let tagManager = TagManagerContainer.getDealerObject();
      if (tagManager && typeof tagManager.getContactUsOpenEvent === "function") {
        tagManager.getContactUsOpenEvent();
      }
    },
    getLeadTypeId() {
      if (window.isFdDealer && this.pageName === "privateOffers") {
        return 220;
      }
      return 23;
    },
    ontcpChecked($event) {
      this.tcpChecked = $event;
    },
    iframehide() {
      this.$emit("hidemodal", false);
    },
    getSetContactDetailsFilled() {
      if (+this.offercategoryid === 2) {
        this.contactdetails["LeadTypeName"] =
          window.isFdDealer && this.pageName === "privateOffers"
            ? "get-private-offer"
            : "get-service-offer-CRM";
        this.contactdetails["LeadTypeID"] =
          window.isFdDealer && this.pageName === "privateOffers" ? 220 : 87;
      } else {
        this.contactdetails["LeadTypeName"] =
          window.isFdDealer && this.pageName === "privateOffers"
            ? "get-private-offer"
            : "get-offer-CRM";
        this.contactdetails["LeadTypeID"] = this.getLeadTypeId();
      }
      this.contactdetails["websiteUrlLeadSubmitted"] = window.location.href;
      this.contactdetails["OfferID"] = parseInt(this.offerid);
      this.contactdetails["StyleID"] = this.styleid;
      this.contactdetails["Vin"] = this.vin;
      this.contactdetails["DealerID"] = window.accountId ? window.accountId : "";
      this.contactdetails["AccountId"] = window.accountId ? window.accountId : "";
      this.contactdetails["VDPAccountId"] = window.vdpAccountId ? +window.vdpAccountId : 0;
      this.contactdetails["campaignID"] = window.campaignId ? window.campaignId : "";
      this.contactdetails["eventId"] = this.consumereventid
        ? this.consumereventid
        : Events.eventsConstants.submitgetoffer;
      this.contactdetails["zip"] = this.contactdetails.Zip;
      this.contactdetails["offerCategoryId"] = parseInt(this.offercategoryid);
      this.contactdetails["userPin"] = window.userpin;
      this.contactdetails["email"] = this.contactdetails.EmailAddress;
      this.contactdetails["offerDesignId"] = parseInt(this.offerdesignid);
      this.contactdetails["firstName"] = this.contactdetails.FirstName;
      this.contactdetails["lastName"] = this.contactdetails.LastName;
      this.contactdetails["phoneNumber"] = this.contactdetails.PhoneNumber;
      this.contactdetails["comments"] = this.contactdetails.Message;
      this.contactdetails["dealergroupid"] = DealerGroupService.getDgId();
    },
    submitEvent() {
      let tagManager = TagManagerContainer.getDealerObject();
      if (tagManager && typeof tagManager.getContactUsSubmitEvent === "function") {
        tagManager.getContactUsSubmitEvent();
      }
    },

    onFormFocus(event) {
      FormOpening.focusEvent(
        event,
        {
          ...this.contactdetails,
          LeadTypeID: this.pageName === "privateOffers" ? this.getLeadTypeId() : 87,
          LeadTypeName: "get-offer-CRM",
        },
        this.vin
      );
    },
    updateMarketingconcent(event) {
      this.marketingTextConsent = event;
    },
    async submitOffer() {
      let validations = new Validations();
      const errorObj = {
        firstNameError: false,
        lastNameError: false,
      };
      this.errordetails = { ...errorObj, ...this.errordetails };
      this.errordetails.firstNameError = validations.validateName(this.contactdetails.FirstName);
      this.errordetails.lastNameError = validations.validateName(this.contactdetails.LastName);
      this.errordetails.emailerror = validations.checkEmail(this.contactdetails.EmailAddress);
      if (this.showZipCodeOnGetOffer) {
        this.errordetails.ziperror = validations.checkZip(this.contactdetails.Zip);
      }

      if (this.isPhoneOnGetOffer) {
        this.errordetails.phoneerror = false;
        this.errordetails.phoneerror = validations.checkPhonemandatory(
          this.contactdetails.PhoneNumber
        );
      }

      this.errordetails.commentserror = false;
      this.errordetails.commentserror =
        this.showCommentsOnGetOffer &&
        validations.checkCommentsMandatory(this.contactdetails.Message);

      if (this.contactdetails?.PhoneNumber?.trim()) {
        this.errordetails.phoneerror = validations.checkPhone(this.contactdetails.PhoneNumber);
      }

      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      const eventCondition =
        this.referFrom !== "dealer" && this.referFrom !== "new" && this.referFrom !== "preowned";
      if (
        eventCondition &&
        fdEvents &&
        typeof fdEvents.accountPageGetOfferSubmitEvent === "function"
      ) {
        fdEvents.accountPageGetOfferSubmitEvent();
      }
      if (
        (this.referFrom === "dealer" ||
          this.referFrom === "new" ||
          this.referFrom === "preowned") &&
        fdEvents &&
        typeof fdEvents.newSpecialsEmailOfferFormOnSubmit === "function"
      ) {
        const refer = this.referFrom === "preowned" ? "pre-owned" : this.referFrom;
        fdEvents.newSpecialsEmailOfferFormOnSubmit(refer);
      }
      if (this.loadShiftSpecialFields) {
        //shift bmw ccpa and tcpa disclaimer checkboxes
        validations.checkShiftOnlyCcpaDisclaimer(this.contactdetails, this.errordetails);
      }
      if (validations.checkError(this.errordetails)) {
        this.disableSubmit = true;
        this.contactdetails["TCPConsent"] = this.tcpChecked;

        this.getSetContactDetailsFilled();
        let tagManager = TagManagerContainer.getDealerObject();
        if (tagManager && typeof tagManager.getFormSubmit === "function") {
          let formValues = "";
          formValues =
            +this.offercategoryid === 2
              ? [...DWP_SERVICE_CONTACT_90610]
              : [...DWP_Sales_Form_90508];
          tagManager.getFormSubmit(formValues[0], formValues[1]);
        }

        if (this.isStellantisProgram) {
          this.contactdetails.Message = `${this.contactdetails.Message} Marketing Text Consent: ${this.marketingTextConsent}`;
        }

        LocalStorageService.setContactdetailsInLocalStorage(this.contactdetails);
        this.contactdetails = {
          ...this.contactdetails,
          ...UtmUrlService.getUrl(),
          ...{ sessionId: window.tid },
        };

        if (
          !LeadFormSpamCheck.checkLeadIsValid(
            this.contactdetails.EmailAddress,
            23,
            this.contactdetails
          )
        ) {
          this.success = true;
          this.initialdisplay = false;
          return false;
        }
        this.submitEvent();
        let eventModel;
        try {
          let response = await LogLeadApi(this.contactdetails);
          fireTagSpecialPriceEvent({
            promotion_name: "get offer popup",
            department: !findIsSalesEventId(this.getLeadTypeId()) ? SERVICE_FORM : SALES_FORM,
            element_position: "popup",
            flow_outcome: "submit",
          });
          this.disableSubmit = false;

          this.success = true;
          this.initialdisplay = false;

          if (this.shiftDigital) {
            this.shiftDigital.submitFormEvent(response.data, this.formShiftDigitalType);
          }

          FormOpening.submitForm(
            SUBMIT_GET_OFFER_LABEL_UNITE_DIGITAL,
            {
              FirstName: this.contactdetails.FirstName,
              LastName: this.contactdetails.LastName,
              Email: this.contactdetails.EmailAddress,
              Phone: this.contactdetails.EmailAddress,
            },
            VEHICLE_OFFER_UNITE_OBJECT
          );
          let tealium = TealiumTireThreeTagManagerContainer.getDealerObject();
          if (tealium && typeof tealium.formSubmitEventsTealium === "function") {
            tealium.formSubmitEventsTealium(
              {
                lead: response.data,
                email: this.contactdetails.EmailAddress,
                phone: this.contactdetails.EmailAddress,
              },
              "",
              "get_offer"
            );
          }

          //log consumer event
          eventModel = {
            ...Events.consumerEventModel,
            logLeadItemId: response.data,
            consumerEventId: this.consumereventid
              ? this.consumereventid
              : Events.eventsConstants.submitgetoffer,
            pin: window.userDetails.userpin,
            vin: this.vin ? this.vin : 0,
            styleId: this.styleid ? this.styleid : 0,
            offerId: this.offerid ? this.offerid : 0,
            vehicleMake: this.make ? this.make : "",
            vehicleModel: this.model ? this.model : "",
            emailAddress: this.contactdetails.EmailAddress,
            phoneNumber: this.contactdetails.PhoneNumber,
            stockNumber: this.stockNumber ? this.stockNumber : "",
          };
          if (window.isFdDealer && this.pageName === "privateOffers") {
            this.contactdetails = {
              ...this.contactdetails,
              amount: this.amount,
              description: this.description,
              header: this.header,
              disclaimer: this.disclaimer,
            };
          }
          axios
            .post(
              `${window.ApiBaseUrl}/Email/${
                window.isFdDealer && this.pageName === "privateOffers"
                  ? "privateoffers"
                  : "specials"
              }`,
              this.contactdetails
            )
            .then((response) => {
              this.success = true;
            });
          Events.logConsumerEvent(eventModel);
        } catch (e) {
          console.log(e);
          this.disableSubmit = false;
        }

        if (this.isAidoEvent) {
          eventModel = {
            ...Events.consumerEventModel,
            consumerEventId: this.consumereventid,
            pin: window.userDetails.userpin,
            vin: this.vin ? this.vin : 0,
            styleId: this.styleid ? this.styleid : 0,
            vehicleMake: this.make ? this.make : "",
            vehicleModel: this.model ? this.model : "",
            offerId: this.offerid ? this.offerid : 0,
            stockNumber: this.stockNumber ? this.stockNumber : "",
          };
          Events.logConsumerEvent(eventModel);
        }

        try {
          //Log Google Bind Event
          let facebookUserDetails = frameFaceBookUserDetails(
            "",
            "",
            eventModel.phoneNumber,
            eventModel.emailAddress
          );

          if (
            this.consumereventid === Events.eventsConstants.GotServiceCoupon ||
            this.consumereventid === Events.eventsConstants.gotPreownedOffer
          )
            //Coupon and Pre-Owned Specials Got Offer click
            logGoogleBingEvent(
              "Email",
              "Submit",
              "Getoffer_service",
              1,
              "Get Offer Submit Click - Service",
              facebookUserDetails
            );
          //Specials Got Offer click
          else
            logGoogleBingEvent(
              "Email",
              "Submit",
              "Getoffer_sales",
              1,
              "Get Offer Submit Click - Sales",
              facebookUserDetails
            );
        } catch (e) {
          console.log(e);
        }
      }
    },
    removeSpecialCharacter(event) {
      let validations = new Validations();
      return validations.isSpecialCharacter(event);
    },
  },
};
</script>
<style>
.color-white {
  color: #fff;
}

.error {
  border: 1px solid red;
}

.iframe-modal .modal-content {
  margin-top: 200px;
}

@media (max-width: 767px) {
  .iframe-modal .modal-content {
    margin-top: 60px;
  }
}

.modal-content {
  border: 0;
}

.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
}

.custom-checkbox:hover input ~ .checkmark {
  background-color: #fff;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.custom-checkbox .checkmark:after {
  left: 8px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
#getoffer .primaryicon-times:before {
  content: "\0058";
  font-size: 14px;
}

[class^="primaryicon-"],
[class*=" primaryicon-"] {
  font-family: "primaryicon-icons", sans-serif !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.primary-close-circle {
  border-radius: 24px;
  border: 1px solid #ccc;
  padding: 8px 10px;
  font-size: 10px;
  text-align: center;
  display: inline-block;
}
#getoffer .mazda-close-icon .primaryicon-times:before {
  content: "\E96D";
  font-size: 30px;
}
</style>
